import $ from 'jquery';

/*
elements = {
    list_items: JQuery object
}
 */

function MapLocationList(model, elements, mapView) {
  this.model = model;
  this.elements = elements;
  this.mapView = mapView;
  this.model.addListener(this);
  this.init();
}

MapLocationList.prototype = {
  init() {
    const obj = this;
    this.elements.list_items.on('mouseenter', function() {
      obj.model.setLocationActive($(this).attr('data-id'));
    });
    this.elements.list_items.on('mouseleave', function() {
      obj.model.setLocationInactive($(this).attr('data-id'));
    });
    this.elements.list_items.on('click', function(eventObj) {
      if (obj.mapView.isMapVisible()) {
        eventObj.preventDefault();
        obj.model.selectLocation($(this).attr('data-id'));
      }
    });
  },

  getElement(id) {
    return this.elements.list_items.filter('[data-id="' + id + '"]');
  },

  onLocationBlur(id) {
    this.getElement(id).removeClass('selected');
  },

  onLocationFocus(id) {
    this.getElement(id).addClass('selected');
  },

  onSelect(eventOb) {
    this.getElement(eventOb.new).addClass('selected');
    this.getElement(eventOb.old).removeClass('selected');
  },
};

export default MapLocationList;



// WEBPACK FOOTER //
// ./src/js/maps/MapLocationList.js